import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'components/styled/button'
import { Subtitle } from 'components/styled/typography'
import { Flex } from 'components/styled/containers/flex'
import { mapLanguageToComponentProps } from 'i18n'
import styled from 'styled-components'


const propTypes = {
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    confirm: PropTypes.object,
  }).isRequired,
}

const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: center;
  text-align: center;
  height: 100%;
`

export function Confirm({ message, onCancel, onConfirm, i18n }) {
  return (
    <ConfirmContainer>
      <Subtitle>{message}</Subtitle>
      <Flex mt="s12" justifyContent="space-between">
        <Button
          className="cancel"
          variant="secondary"
          icon="delete"
          onClick={onCancel}
          text={i18n.confirm.cancel}
        />
        <Button
          className="confirm"
          onClick={onConfirm}
          text={i18n.confirm.confirm}
        />
      </Flex>
    </ConfirmContainer>
  )
}

Confirm.propTypes = propTypes

export default connect(mapLanguageToComponentProps())(Confirm)
